module.exports = __webpack_public_path__ + "img/border_invertedTriangle.10a5eba0.svg";